import React from 'react';
import { FieldArray } from 'redux-form';

import { EMPLOYEE_FORM } from 'src/constants/FormNames';
import { PlusSquare } from 'jbc-front/components/icons';
import BankItemSectionContainer from '../containers/BankItemSectionContainer';
import {withTranslation} from 'react-i18next'
const NUMBER_OF_MAX_EMPLOYEE_BANK = 6;

const Banks = ({ fields, lastNameKana, firstNameKana ,t }) => (
  <div>
    {fields.map((bank, index) => (
      <BankItemSectionContainer
        key={bank}
        index={index}
        formKey={bank}
        formName={EMPLOYEE_FORM}
        remove={() => fields.remove(index)}
      />
    ))}
    {fields.length < NUMBER_OF_MAX_EMPLOYEE_BANK && (
      <div className="u-mt20 u-mb20">
        <div role="button" tabIndex="0" onClick={() => fields.push({})} className="u-txt-addinfo">
        {/* <div
          role="button"
          tabIndex="0"
          onClick={() => {
            fields.push({ accountHolderKana: [lastNameKana, firstNameKana].filter(word => word !== '').join('　') });
          }}
          className="u-txt-addinfo"
        > */}
          <PlusSquare size={20} className="u-txt-addinfo-icon" />{t('features.Employees.components.BankItemSection.add_new_bank_account')}
        </div>
      </div>
    )}
  </div>
);
const BanksSection = ({ lastNameKana, firstNameKana, t }) => (
  // <FieldArray name="employeeBanks" component={Banks} lastNameKana={lastNameKana} firstNameKana={firstNameKana} t={t} />
  <FieldArray name="employeeBanks" component={Banks} t={t} />
);

export default withTranslation()(BanksSection);
